/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

/**
 *
 *
 * 1 = NotTested
 *
 * 2 = OK
 *
 * 3 = Warning
 *
 * 4 = NOTOK
 */
export enum VHCRecordConditionEnum {
  NotTested = 1,
  OK = 2,
  Warning = 3,
  NOTOK = 4,
}
